import React, { ReactElement } from 'react';

import { FooterItem, Footer } from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';

import { FooterContent } from './FooterContent';
import { FooterLink } from './styles';
import dataQaIds from '../../dataModel/dataQaIds';

export default function FooterComponent(): ReactElement {
  const { footerContent } = useContent<FooterContent>();
  return (
    <Footer marginTop="03" data-qa-id={dataQaIds.footer.container}>
      {footerContent &&
        footerContent.map(({ link, text }) => (
          <FooterItem key={text}>
            <FooterLink target="_blank" href={link}>
              {text}
            </FooterLink>
          </FooterItem>
        ))}
    </Footer>
  );
}
